import store from "@/store";

export const PartyColor = {
  methods: {
    getPartyColor(partyId) {
      let party = store.getters["party/party"](partyId);
      if (party && party.color) {
        return party.color;
      }
      return "#808080";
    }
  }
};
